/* Element positions */

/**
 * @param object (html element)
 * @returns object { left: number, top: number }
 */
const getRect = (el) => {
  return el.getBoundingClientRect();
}

/**
 * @param object (html element)
 * @returns object { left: number, top: number }
 */
const getOffset = (el) => {
  const rect = getRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}

export default {
  getRect: getRect,
  getOffset: getOffset,
};
